import { AppBar, Button, Hidden, IconButton, Toolbar } from '@material-ui/core';
import { Flex, LogoutButton } from 'components';
import React from 'react';
import Menu from '@material-ui/icons/Menu';

interface Props {
  onSidebarOpen: () => void;
}

const Topbar = ({ onSidebarOpen }: Props) => {
  return (
    <AppBar>
      <Toolbar>
        <Button style={{ color: 'white', width: 150, marginLeft: 20 }}>
          <img src="/home.png" width="100%" />
        </Button>
        <Flex.Grow />
        <LogoutButton />
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onSidebarOpen}>
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
